import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { SuiteExecutionStatus } from '@flowqa/shared';

export type CloneExecutionSortDirection = 'asc' | 'desc';
export type CloneExecutionSortKey =
  | 'suiteName'
  | 'status'
  | 'tests'
  | 'durationMs'
  | 'timestamp'
  | 'runNumber'
  | 'runId';

export const cloneExecutionDefaultSortKey: CloneExecutionSortKey = 'timestamp';
export const cloneExecutionDefaultSortDirection: CloneExecutionSortDirection = 'desc';

export const cloneExecutionSortOptions: Array<{
  key: CloneExecutionSortKey;
  label: string;
}> = [
  { key: 'suiteName', label: 'Suite Name' },
  { key: 'status', label: 'Status' },
  { key: 'tests', label: 'Tests' },
  { key: 'durationMs', label: 'Duration' },
  { key: 'timestamp', label: 'Executed' },
  { key: 'runNumber', label: 'Run' },
  { key: 'runId', label: 'Details' },
];

export const cloneExecutionSortFieldMap: Record<CloneExecutionSortKey, string> = {
  suiteName: 'suiteName',
  status: 'status',
  tests: 'tests',
  durationMs: 'durationMs',
  timestamp: 'timestamp',
  runNumber: 'runNumber',
  runId: 'runId',
};

export const cloneExecutionColumnOptions: Array<{
  field: string;
  label: string;
  mandatory?: boolean;
}> = [
  { field: 'name', label: 'Suite', mandatory: true },
  { field: 'status', label: 'Status' },
  { field: 'tests', label: 'Tests' },
  { field: 'runNumber', label: 'Run' },
  { field: 'runId', label: 'Details' },
];

export const cloneExecutionStatusOptions: Array<{
  value: SuiteExecutionStatus;
  label: string;
}> = [
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'errored', label: 'Errored' },
  { value: 'skipped', label: 'Skipped' },
];

export const cloneExecutionDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  status: true,
  tests: true,
  runNumber: true,
  runId: true,
};
